module.exports = __webpack_public_path__ + "img/change_template_banner.22651db0.webp";